import {
  CREATE_CONTACT_LOG_REQUEST,
  CREATE_CONTACT_LOG_SUCCESS,
  CREATE_CONTACT_LOG_FAILURE,
  FETCH_CONTACT_LOGS_REQUEST,
  FETCH_CONTACT_LOGS_SUCCESS,
  FETCH_CONTACT_LOGS_FAILURE,
  FETCH_USER_CONTACT_LOGS_REQUEST,
  FETCH_USER_CONTACT_LOGS_SUCCESS,
  FETCH_USER_CONTACT_LOGS_FAILURE,
  UPDATE_CONTACT_LOG_REQUEST,
  UPDATE_CONTACT_LOG_SUCCESS,
  UPDATE_CONTACT_LOG_FAILURE,
  DELETE_CONTACT_LOG_REQUEST,
  DELETE_CONTACT_LOG_SUCCESS,
  DELETE_CONTACT_LOG_FAILURE,
} from "./types";

import {
  createContactLog,
  fetchContactLogs,
  fetchUserContactLogs,
  updateContactLog,
  deleteContactLog,
} from "../../services/contactLogService";

// CREATE
export const createContactLogAction = (data) => async (dispatch) => {
  dispatch({ type: CREATE_CONTACT_LOG_REQUEST });

  try {
    const response = await createContactLog(data);

    if (response.success) {
      dispatch({ type: CREATE_CONTACT_LOG_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    } else {
      dispatch({ type: CREATE_CONTACT_LOG_FAILURE, payload: response.error });
      return { success: false, error: response.error };
    }
  } catch (error) {
    dispatch({
      type: CREATE_CONTACT_LOG_FAILURE,
      payload: error.message,
    });
  }
};

// FETCH
export const fetchContactLogsAction =
  (page = 1, size = 10) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CONTACT_LOGS_REQUEST });

    try {
      const response = await fetchContactLogs(page, size);

      if (response.success) {
        dispatch({
          type: FETCH_CONTACT_LOGS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_CONTACT_LOGS_FAILURE,
          payload: response.error,
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_CONTACT_LOGS_FAILURE,
        payload: error.message,
      });
    }
  };

 //FETCH FOR USER
 export const fetchUserContactLogsAction =
  (userId) =>
  async (dispatch) => {

    dispatch({
      type: FETCH_USER_CONTACT_LOGS_REQUEST,
    });

    try {

      if (!userId) {

        const error =
          "User ID is required";

        dispatch({
          type: FETCH_USER_CONTACT_LOGS_FAILURE,
          payload: error,
        });

        return {
          success: false,
          error,
        };
      }

      const response =
        await fetchUserContactLogs(
          userId
        );

      if (response.success) {

        dispatch({
          type: FETCH_USER_CONTACT_LOGS_SUCCESS,
          payload: response.data,
        });

        return {
          success: true,
          data: response.data,
        };

      } else {

        dispatch({
          type: FETCH_USER_CONTACT_LOGS_FAILURE,
          payload: response.error,
        });

        return {
          success: false,
          error: response.error,
        };
      }

    } catch (error) {

      dispatch({
        type: FETCH_USER_CONTACT_LOGS_FAILURE,
        payload: error.message,
      });

      return {
        success: false,
        error: error.message,
      };
    }
  }; 

// UPDATE
// UPDATE
export const updateContactLogAction =
  (logId, data) =>
  async (dispatch) => {
    dispatch({
      type: UPDATE_CONTACT_LOG_REQUEST,
    });

    try {
      const response =
        await updateContactLog(
          logId,
          data
        );

      if (response.success) {
        dispatch({
          type:
            UPDATE_CONTACT_LOG_SUCCESS,
          payload:
            response.data,
        });
      } else {
        dispatch({
          type:
            UPDATE_CONTACT_LOG_FAILURE,
          payload:
            response.error,
        });
      }

      return response;

    } catch (error) {

      dispatch({
        type:
          UPDATE_CONTACT_LOG_FAILURE,
        payload:
          error.message,
      });

      return {
        success: false,
        error: error.message,
      };
    }
  };

// DELETE
export const deleteContactLogAction = (logId) => async (dispatch) => {
  dispatch({ type: DELETE_CONTACT_LOG_REQUEST });

  try {
    const response = await deleteContactLog(logId);

    if (response.success) {
      dispatch({
        type: DELETE_CONTACT_LOG_SUCCESS,
        payload: logId,
      });
    } else {
      dispatch({
        type: DELETE_CONTACT_LOG_FAILURE,
        payload: response.error,
      });
    }
  } catch (error) {
    dispatch({
      type: DELETE_CONTACT_LOG_FAILURE,
      payload: error.message,
    });
  }
};